const getters = {
  getPicklocations: (state) => (orderIds) => {
    let pickLocations = _.toArray(state.pickLocations);
    return _.filter(pickLocations, (pickloc) => {
          return _.includes(orderIds, pickloc.orderId);
        }
    );
  },
  getPickLocationsForOrder: (state) => (id) => {
    return _.filter(state.pickLocations, (location) => {
          return id == location.orderId;
        }
    );
  },
  getLocation: (state) => (id) => {
    return state.pickLocations[id] ? state.pickLocations[id] : false;
  },

  getPickLocationsOfCargo: (state, getters, rootState, rootGetters) => (id) => {
    let pickLocations = [];
    let orders = rootGetters['orders/getOrderIdsFromCargo'](parseInt(id));
    orders.forEach(order => {
      let locations = getters.getPickLocationsForOrder(parseInt(order));

      pickLocations = pickLocations.concat(locations);
    });
     return pickLocations;
  }
};

export default getters;